import { AuthCenteredLayout, ForgotPasswordForm, useForgotPasswordScreen } from '@/features/auth';
import Notice from '@/shared/ui/Notice';

export default function ForgotPasswordPage() {
  const screen = useForgotPasswordScreen();

  return (
    <AuthCenteredLayout
      title="Password dimenticata"
      description="Inserisci la tua email: ti invieremo un link per reimpostare la password."
    >
      {screen.error && (
        <Notice tone="danger" className="mt-6">
          {screen.error}
        </Notice>
      )}
      {screen.sent ? (
        <Notice tone="success" focusOnMount className="mt-6">
          Se esiste un account associato, riceverai una email con le istruzioni.
        </Notice>
      ) : (
        <ForgotPasswordForm submitting={screen.submitting} onSubmit={screen.submit} />
      )}
    </AuthCenteredLayout>
  );
}
